import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "patient-details" }
const _hoisted_2 = { class: "profile-status" }
const _hoisted_3 = {
  key: 0,
  class: "fw-bold"
}
const _hoisted_4 = { class: "pic" }
const _hoisted_5 = {
  key: 1,
  class: "no-pic fas fa-user"
}
const _hoisted_6 = { class: "fw-bold" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_HCPatientMain = _resolveComponent("HCPatientMain")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.getBranchName)
        ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(_ctx.getBranchName.name), 1 /* TEXT */))
        : _createCommentVNode("v-if", true),
      _createElementVNode("div", _hoisted_4, [
        (_ctx.selectedPatientDetails.photoUrl)
          ? (_openBlock(), _createElementBlock("span", {
              key: 0,
              class: "uploaded-pic",
              ref: "userPicElement",
              style: _normalizeStyle({ backgroundImage: `url(${_ctx.selectedPatientDetails.photoUrl})` })
            }, null, 4 /* STYLE */))
          : (_openBlock(), _createElementBlock("i", _hoisted_5))
      ]),
      _createElementVNode("p", _hoisted_6, _toDisplayString(String(_ctx.statusEnum.getDescriptionUsingValue(_ctx.selectedPatientDetails.status)).toLocaleUpperCase()), 1 /* TEXT */)
    ]),
    _createVNode(_component_HCPatientMain, { selectedPatientDetails: _ctx.selectedPatientDetails }, null, 8 /* PROPS */, ["selectedPatientDetails"])
  ]))
}